import { createSlice } from '@reduxjs/toolkit';

import { IVacanciesState } from './interfaces';
import { loadVacanciesItem, loadVacanciesList } from './actions';

export const vacanciesSlice = createSlice({
  name: 'vacancies',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as IVacanciesState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadVacanciesList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadVacanciesItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
